import type { ServerConfig } from '@/@types';

export const serverConfig: ServerConfig = {
  subject: '开发环境',
  environment: 'development',
  apiSrc: 'https://saas-api1.pdaia.cn',
  // apiSrc: 'http://192.168.2.46:8080',
  // apiSrc: 'http://192.168.3.185:8080',
  questionarySrc: 'https://que-design-lite1.pdaia.cn',
};
